export const PLY_MAIL = 'PLY_MAIL';
export const CHROME_STORE = 'CHROME_STORE';
export const MARKETPLACE = 'MARKETPLACE';
export const LANDING_PAGE = 'LANDING_PAGE';
export const OTHER = 'OTHER';

export const LANDING_PAGE_ROUTE = '/home';

export const ORIGINS = {
	PLY_MAIL,
	CHROME_STORE,
	MARKETPLACE,
	LANDING_PAGE,
	OTHER,
};

export const ORIGINS_TO_RETURN_URL_MAP = {
	[PLY_MAIL]: '/flows',
	[CHROME_STORE]: LANDING_PAGE_ROUTE,
	[MARKETPLACE]: '/installables/',
	[LANDING_PAGE]: LANDING_PAGE_ROUTE,
	[OTHER]: LANDING_PAGE_ROUTE,
};

export const COMPANY_ROLE = ['Team member', 'Team leader', 'Director / VP', 'C-level / Owner', 'Freelancer'];

export const COMPANY_FUNCTION = [
	'Ops',
	'Product',
	'Management',
	'Customer Success',
	'Sales',
	'Marketing',
	'Engineering',
	'Project Management',
	'Design',
	'Human Resources',
	'Finance or Legal',
	'Administration',
	'Other',
];

export const COMPANY_SIZE = ['Just me', '1-4', '5-19', '20-49', '50-99', '100-249', '250-999', '1000+'];
